import styled from 'styled-components';
import { contentCentered } from 'helpers/styles.js';
import { EntityIcon, StyledEntityItem } from 'components/Global/EntityItem/styled.js';

export const StyledPowerSearchContainer = styled.div`
  height: 100%;
  background:linear-gradient(127.45deg, #2B4F70 0%, #122333 100%);
  width: 1000px;
  border-radius: 20px;
  width: 100%;
  margin: auto;
  ${contentCentered};
`;

export const CenterContainer = styled.div`
  width: 90%;
  text-align: left;
  max-width: 900px;
`;

export const StyledSearchInput = styled.input`
  border: 0;
  background: none;
  font-size: 12px;
  color: white;

  &::placeholder {
    color: ${({ theme }) => theme.colors.palette[5]};
  }

  &:focus {
    outline: none;
  }
`;

export const SearchContainer = styled.div`
  min-height: 45px;
  width: 100%;
  padding: 10px 0 5px 0;
  border-bottom: ${({ disabled }) => `1px solid ${disabled ? 'slategrey' : '#82B2DB'}`};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'default'};
`;

export const SearchSuggestionContainer = styled.div`
  position: absolute;
  font-size: 12px;
  color: white;
  background: #2B4F70;
  border-radius: 5px;
  height: 180px;
  width: 250px;
  padding: 12px;
  z-index: 2;
`;

export const EntityContainer = styled.div`
  padding: 6px 0;
  cursor: pointer;
`;

export const SelectedDeleteButton = styled.div`
  position: absolute;
  top: 7px;
  right: 10px;
  bottom: auto;
  left: auto;
  color: white;
  background: rgba(0, 0, 0, 0.16);
  border-radius: 100%;
  width: 15px;
  height: 14px;
  line-height: 18px;
  font-size: 14px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

export const SelectedEntity = styled.div`
  font-size: 12px;
  margin-right: 3px;
  border-radius: 30px;
  padding: 4px;
  padding-right: 32px;
  background-color: ${({ theme }) => theme.colors.palette[7]};
  display: inline-block;
  position: relative;

  ${EntityIcon} {
    width: 20px;
    height: 20px;
  }

  ${StyledEntityItem} {
    padding-left: 5px;
  }
`;

export const SelectedKeyword = styled(SelectedEntity)`
  padding: 7px 37px 7px 17px;

  ${SelectedDeleteButton} {
    top: 6px;
  }
`;


export const InputLabel = styled.div`
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  padding: 10px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ disabled }) => disabled ? 'slategrey' : 'white'};
`;

export const Keyword = styled.div`
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;

  color: #FFFFFF;
`;

export const SubmitButton = styled.div`
  border-radius: 30px;
  border: 1px solid #FFFFFF;
  font-size: 9px;
  line-height: 13px;
  margin: auto;
  width: 90px;
  padding: 9px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 24px;
  letter-spacing: 2px;
  opacity: 0.8;
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

export const DateContainer = styled.div`
  .filterItem {
    border: 1px solid #6CA5D6;
    box-sizing: border-box;
    border-radius: 2px;
    background-color: transparent !important;
    height: 30px !important;
    line-height: 22px !important;
    padding: 6px 0;
    color: white !important;
  }
`;
